import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  // On the live site, sign-in runs through theinterconnector.com itself
  // (Firebase Hosting serves /__/auth/handler): sign-in by redirect needs the
  // same domain as the page (utils/socialSignIn.js). Elsewhere (localhost),
  // the firebaseapp.com default.
  authDomain: typeof window !== 'undefined' && window.location.hostname === 'theinterconnector.com'
    ? 'theinterconnector.com'
    : process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
console.log('Firebase initialized');
const auth = firebase.auth();

const GoogleAuthProvider = firebase.auth.GoogleAuthProvider;
const FacebookAuthProvider = firebase.auth.FacebookAuthProvider;

export default firebaseApp;
export { auth, GoogleAuthProvider, FacebookAuthProvider };